import { Toast, Dialog } from 'vant';
import wx from 'jweixin-1.6.0';
import comment from "../../util/comment"

var that;
var timer;
export default {
    setup() {
        const onClickLeft = () => history.back();
        return {
            onClickLeft,
        };
    },
    data() {
        return {
            dhInfoList: [],
            test:"0",
            exposure: {},
            exposureAnswer: {}
        };
    },

    created() {
        that = this;
        this.getExposure();
        this.getExposureAnswer();
    },
    
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer); //关闭
        } //利用vue的生命周期函数
    },

    methods: {
        getExposure() {

            console.log("this.$route.query.getExposureId",this.$route.query.exposureId);

            this.$api.getExposure({
                params: {
                    exposureId: this.$route.query.exposureId,
                },
                success: function (res) {
                    console.log("getExposure", res.data);
                    that.exposure = res.data
                }
            })
        },
        getExposureAnswer() {
            console.log("this.$route.query.getExposureAnswerId",this.$route.query.exposureId);
            this.$api.getExposureAnswer({
                params: {
                    exposureId: this.$route.query.exposureId,
                },
                success: function (res) {
                    console.log("getExposureAnswer", res.data);
                    that.exposureAnswer = res.data
                }
            })
        },
    }
};
